module.exports = __webpack_public_path__ + "static/media/icon-arrow-grey.647b092c.png";